import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { operations } from "@/api/schema";

import { toReturnRec } from "../lib/return-vm";

export interface ReturnFilters {
  marketplace?: string;
  search?: string;
  date_from?: string;
  date_to?: string;
  limit?: number;
  offset?: number;
}

type ListReturnsQuery = NonNullable<operations["listReturns"]["parameters"]["query"]>;

export function useReturns(f: ReturnFilters) {
  return useQuery({
    queryKey: ["returns", f],
    queryFn: async () => {
      // Build query params — only include defined values to avoid sending empty strings.
      // exactOptionalPropertyTypes=true prevents assigning `undefined` via normal assignment;
      // we spread conditionally and cast the result to the schema type at this boundary.
      const query = {
        ...(f.marketplace !== undefined && { marketplace: f.marketplace }),
        ...(f.search !== undefined && { search: f.search }),
        ...(f.date_from !== undefined && { date_from: f.date_from }),
        ...(f.date_to !== undefined && { date_to: f.date_to }),
        ...(f.limit !== undefined && { limit: f.limit }),
        ...(f.offset !== undefined && { offset: f.offset }),
      } as ListReturnsQuery;

      const { data, error } = await apiClient.GET("/v1/returns", {
        params: { query },
      });
      if (error) throw error;
      // BE may return a thinner projection than the return views render;
      return {
        returns: (data?.data ?? []).map(toReturnRec),
        total: data?.total ?? 0,
      };
    },
  });
}
